import React from "react";
import { withTranslation } from "react-i18next";
import { Badge } from "react-bootstrap";
import { dataPointShowsExpectedBaseline } from "../../../../../core/constants/anomalyRuleCodes";
import { SEVERITY_BADGE } from "../constants/timelineSeverity";
import {
  formatDeviation,
  formatSeverityLabel,
  formatTimelinePeriod,
  formatValue,
} from "../utils/timelineFormatters";
const STATUS_INTERPRETATION = {
  "": "MetricAnomalyTimeline.statusInterpretAll.label",
  OPEN: "MetricAnomalyTimeline.statusInterpretOpen.label",
  DISMISSED: "MetricAnomalyTimeline.statusInterpretDismissed.label",
  RESOLVED: "MetricAnomalyTimeline.statusInterpretResolved.label",
};

const SelectedPeriodPanel = ({ t, dataPoint, statusFilter, ruleCode }) => {
  if (!dataPoint) {
    return (
      <div className="mat-investigation-panel anomaly-glass-focus-panel">
        <h6>{t("MetricAnomalyTimeline.investigationPanel.label")}</h6>
        <p className="mat-panel-empty">{t("MetricAnomalyTimeline.selectPeriodHint.label")}</p>
      </div>
    );
  }

  const isMissing = dataPoint.value == null;
  const showExpectedValue = dataPointShowsExpectedBaseline(ruleCode, dataPoint);

  return (
    <div className="mat-investigation-panel anomaly-glass-focus-panel" data-testid="mat-investigation-panel">
      <h6>{t("MetricAnomalyTimeline.investigationPanel.label")}</h6>
      <dl className="mat-investigation-dl">
        <dt>{t("AnomalyDetection.period.label")}</dt>
        <dd>{formatTimelinePeriod(dataPoint.period)}</dd>
        <dt>{t("MetricAnomalyTimeline.reportedValue.label")}</dt>
        <dd>{isMissing ? t("MetricAnomalyTimeline.missingValue.label") : formatValue(dataPoint.value)}</dd>
        {showExpectedValue && (
          <>
            <dt>{t("AnomalyDetection.expectedValue.label")}</dt>
            <dd>{formatValue(dataPoint.expectedValue)}</dd>
          </>
        )}
        <dt>{t("MetricAnomalyTimeline.deviation.label")}</dt>
        <dd>{formatDeviation(dataPoint.maxDeviationPct, t)}</dd>
        <dt>{t("AnomalyDetection.anomalyCount.label")}</dt>
        <dd>{dataPoint.anomalyCount ?? 0}</dd>
        <dt>{t("AnomalyDetection.severity.label")}</dt>
        <dd>
          {dataPoint.maxSeverity ? (
            <Badge bg={SEVERITY_BADGE[dataPoint.maxSeverity] || "secondary"}>
              {formatSeverityLabel(dataPoint.maxSeverity, t)}
            </Badge>
          ) : (
            "—"
          )}
        </dd>
      </dl>
      {isMissing && dataPoint.hasAnomaly && (
        <div className="mat-callout mat-callout-warning">
          {t("MetricAnomalyTimeline.missingValueCallout.label")}
        </div>
      )}
      {(dataPoint.anomalyCount || 0) > 1 && (
        <div className="mat-callout mat-callout-info">
          {t("MetricAnomalyTimeline.multipleAnomaliesCallout.label", {
            count: dataPoint.anomalyCount,
          })}
        </div>
      )}
      <p className="mat-status-interpretation">
        {t(STATUS_INTERPRETATION[statusFilter] || STATUS_INTERPRETATION[""])}
      </p>
    </div>
  );
};

export default withTranslation()(SelectedPeriodPanel);
